module.exports = __webpack_public_path__ + "img/icn-lecture points.beaf9de3.svg";